<div 
  class="dialog-body gus-font-light space-letter-047 line-height-24 fs16" 
  *ngIf="!customContent(); else customBodyContent" 
  [innerHTML]="config.body"
>
  <!-- {{ config.body }} -->
</div>

<ng-template #customBodyContent>
  <ng-content select="[gusCustomDialogContent]"></ng-content>
</ng-template>
